// import {
//   Grid,
//   ToggleButton,
//   ToggleButtonGroup,
//   Card,
//   Typography,
//   TextField,
//   InputAdornment,
//   IconButton
// } from "@mui/material";
// import EntityContactInfo from "./EntityContactInfo";
// import IndividualContactInfo from "./IndividualContactInfo";
// import { BlacklistNameEntity, BlacklistNameIndividual } from "./types";
// import { ClearIcon } from "@mui/x-date-pickers";
// import PhonebookContactAutocomplete from "../phonebook/phonebookAutocomplete/PhonebookContactAutocomplete";
// import { Contact as OrderEntryContact } from "../orderEntry/types/Contact";

// interface Props {
//   individualInfo: BlacklistNameIndividual;
//   setIndividualInfo: (e: any, value: any) => void;
//   entityInfo: BlacklistNameEntity;
//   changeEntityInfo: (e: any, value: any) => void;
//   isIndividual: boolean;
//   setIsIndividual: (value: boolean) => void;
//   nameError: boolean;
//   companyError: boolean;
//   onBlurEntity: () => void;
//   onBlurIndividual: () => void;
//   setBlacklistContactFromPhonebookContact: (contact: OrderEntryContact) => void;
// }

// export default function ContactInfo({
//   individualInfo,
//   setIndividualInfo,
//   entityInfo,
//   changeEntityInfo,
//   isIndividual,
//   setIsIndividual,
//   nameError,
//   companyError,
//   onBlurEntity,
//   onBlurIndividual,
//   setBlacklistContactFromPhonebookContact
// }: Props) {
//   const isLookupCodeSet = isIndividual ? Boolean(individualInfo.lookupCode) : Boolean(entityInfo.lookupCode);
//   return (
//     <Card sx={{ p: 3, maxWidth: 760, marginTop: 4 }}>
//       <Grid container justifyContent="space-between" alignItems="center" marginBottom={2}>
//         <Grid item>
//           <Typography variant="h5" marginBottom={2}>
//             Name
//           </Typography>
//           <ToggleButtonGroup size="small" color="primary">
//             <ToggleButton
//               value="Individual"
//               onClick={() => {
//                 setIsIndividual(true);
//               }}
//               selected={isIndividual}
//             >
//               Individual
//             </ToggleButton>
//             <ToggleButton
//               value="Entity"
//               onClick={() => {
//                 setIsIndividual(false);
//               }}
//               selected={!isIndividual}
//             >
//               Entity
//             </ToggleButton>
//           </ToggleButtonGroup>
//         </Grid>

//         {/* {isIndividual ? renderIndividualForm() : renderEntityForm()} */}

//         <Grid item width={"50%"}>
//           {isLookupCodeSet ? (
//             <TextField
//               fullWidth
//               label="Lookup Code"
//               value={individualInfo?.lookupCode}
//               InputProps={{
//                 endAdornment: individualInfo?.lookupCode && (
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label="clear text"
//                       onClick={() => {
//                         setIndividualInfo("lookupCode", "");
//                       }}
//                       edge="end"
//                       size="small"
//                     >
//                       <ClearIcon />
//                     </IconButton>
//                   </InputAdornment>
//                 )
//               }}
//               disabled
//             />
//           ) : (
//             <PhonebookContactAutocomplete
//               isOptionForAddingDisabled
//               isCompany={false}
//               contact={{} as any}
//               setContact={(c) => {
//                 console.log("🚀 ~ ContactInfo ~ c:", c);
//                 if (c) {
//                   setBlacklistContactFromPhonebookContact(c);
//                 }
//               }}
//               textboxLabel={"Add Blacklist From Phonebook"}
//             />
//           )}
//         </Grid>
//       </Grid>

//       {!isIndividual ? (
//         <EntityContactInfo
//           entityInfo={entityInfo}
//           changeEntityInfo={changeEntityInfo}
//           error={companyError}
//           onBlurEntity={onBlurEntity}
//         />
//       ) : (
//         <IndividualContactInfo
//           individualInfo={individualInfo}
//           setIndividualInfo={setIndividualInfo}
//           nameError={nameError}
//           onBlurIndividual={onBlurIndividual}
//         />
//       )}
//     </Card>
//   );
// }

import {
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  Typography,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import EntityContactInfo from "./EntityContactInfo";
import IndividualContactInfo from "./IndividualContactInfo";
import { BlacklistNameEntity, BlacklistNameIndividual } from "./types";
import { ClearIcon } from "@mui/x-date-pickers";
import PhonebookContactAutocomplete from "../phonebook/phonebookAutocomplete/PhonebookContactAutocomplete";
import { Contact as OrderEntryContact } from "../orderEntry/types/Contact";
import { ReactNode } from "react";

type ReviewFieldHoverProps = { onMouseEnter: () => void; onMouseLeave: () => void };

interface Props {
  individualInfo: BlacklistNameIndividual;
  setIndividualInfo: (e: any, value: any) => void;
  entityInfo: BlacklistNameEntity;
  changeEntityInfo: (e: any, value: any) => void;
  isIndividual: boolean;
  setIsIndividual: (value: boolean) => void;
  nameError: boolean;
  companyError: boolean;
  onBlurEntity: () => void;
  onBlurIndividual: () => void;
  setBlacklistContactFromPhonebookContact: (contact: OrderEntryContact, isIndividual: boolean) => void;
  isEditMode?: boolean;
  hideIndividualEntityToggle?: boolean;
  disabled?: boolean;
  renderReviewActions?: (fieldId: string, displayedValue: unknown) => ReactNode;
  getReviewFieldHoverProps?: (fieldId: string) => ReviewFieldHoverProps;
  getReviewFieldHighlightSx?: (fieldId: string) => SxProps<Theme>;
}

export default function ContactInfo({
  individualInfo,
  setIndividualInfo,
  entityInfo,
  changeEntityInfo,
  isIndividual,
  setIsIndividual,
  nameError,
  companyError,
  onBlurEntity,
  onBlurIndividual,
  setBlacklistContactFromPhonebookContact,
  isEditMode,
  hideIndividualEntityToggle,
  disabled,
  renderReviewActions,
  getReviewFieldHoverProps,
  getReviewFieldHighlightSx
}: Props) {
  const isDisabled = Boolean(disabled);

  const renderIndividualForm = () => {
    const isLookupCodeSet = Boolean(individualInfo.lookupCode);
    return (
      <Grid item width={"50%"}>
        {isLookupCodeSet ? (
          <TextField
            fullWidth
            label="Lookup Code"
            value={individualInfo?.lookupCode}
            {...getReviewFieldHoverProps?.("lookupCode")}
            sx={getReviewFieldHighlightSx?.("lookupCode")}
            InputProps={{
              endAdornment: renderReviewActions ? (
                <InputAdornment position="end">{renderReviewActions("lookupCode", individualInfo?.lookupCode)}</InputAdornment>
              ) : individualInfo?.lookupCode && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear text"
                    onClick={() => {
                      setIndividualInfo("lookupCode", "");
                    }}
                    edge="end"
                    size="small"
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            disabled
          />
        ) : (
          <PhonebookContactAutocomplete
            disabled={isDisabled}
            isDisabledOptionForAdding
            isLimitToContactsOnly
            isCompany={false}
            contact={{} as any}
            setContact={(c) => {
              if (c) {
                setBlacklistContactFromPhonebookContact(c, isIndividual);
              }
            }}
            textboxLabel={"Add Blacklist From Phonebook"}
          />
        )}
      </Grid>
    );
  };
  const renderEntityForm = () => {
    const isLookupCodeSet = Boolean(entityInfo.lookupCode);
    return (
      <Grid item width={"50%"}>
        {isLookupCodeSet ? (
          <TextField
            fullWidth
            label="Lookup Code"
            value={entityInfo?.lookupCode}
            {...getReviewFieldHoverProps?.("lookupCode")}
            sx={getReviewFieldHighlightSx?.("lookupCode")}
            InputProps={{
              endAdornment: renderReviewActions ? (
                <InputAdornment position="end">{renderReviewActions("lookupCode", entityInfo?.lookupCode)}</InputAdornment>
              ) : entityInfo?.lookupCode && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear text"
                    onClick={() => {
                      changeEntityInfo("lookupCode", "");
                    }}
                    edge="end"
                    size="small"
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
            disabled
          />
        ) : (
          <PhonebookContactAutocomplete
            disabled={isDisabled}
            isDisabledOptionForAdding
            isLimitToCompaniesOnly
            isCompany={false}
            contact={{} as any}
            setContact={(c) => {
              if (c) {
                setBlacklistContactFromPhonebookContact(c, isIndividual);
              }
            }}
            textboxLabel={"Add Blacklist From Phonebook"}
          />
        )}
      </Grid>
    );
  };

  return (
    <Card sx={{ p: 3, maxWidth: 760, marginTop: 4 }}>
      <Grid container justifyContent="space-between" alignItems="center" marginBottom={2}>
        <Grid item>
          <Typography variant="h5" marginBottom={2}>
            Name
          </Typography>
          {hideIndividualEntityToggle ? (
            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 700 }}>
              {isIndividual ? "Individual" : "Entity"}
            </Typography>
          ) : (
            <ToggleButtonGroup size="small" color="primary">
              <ToggleButton
                value="Individual"
                onClick={() => { if (!isEditMode && !isDisabled) setIsIndividual(true); }}
                selected={isIndividual}
                disabled={isEditMode || isDisabled}
              >
                Individual
              </ToggleButton>
              <ToggleButton
                value="Entity"
                onClick={() => { if (!isEditMode && !isDisabled) setIsIndividual(false); }}
                selected={!isIndividual}
                disabled={isEditMode || isDisabled}
              >
                Entity
              </ToggleButton>
            </ToggleButtonGroup>
          )}
        </Grid>

        {isIndividual ? renderIndividualForm() : renderEntityForm()}
      </Grid>
      {!isIndividual ? (
        <EntityContactInfo
          entityInfo={entityInfo}
          changeEntityInfo={changeEntityInfo}
          error={companyError}
          onBlurEntity={onBlurEntity}
          isEditMode={isEditMode}
          disabled={isDisabled}
          renderReviewActions={renderReviewActions}
          getReviewFieldHoverProps={getReviewFieldHoverProps}
          getReviewFieldHighlightSx={getReviewFieldHighlightSx}
        />
      ) : (
        <IndividualContactInfo
          individualInfo={individualInfo}
          setIndividualInfo={setIndividualInfo}
          nameError={nameError}
          onBlurIndividual={onBlurIndividual}
          isEditMode={isEditMode}
          disabled={isDisabled}
          renderReviewActions={renderReviewActions}
          getReviewFieldHoverProps={getReviewFieldHoverProps}
          getReviewFieldHighlightSx={getReviewFieldHighlightSx}
        />
      )}
    </Card>
  );
}
